import { ReactElement, useRef } from 'react'
import { useAtom, useAtomValue } from 'jotai'
import { modalStatusAtom, selectedAccountAtom } from 'store/atoms'

import {
  changePaymentDueDateModalContainerId,
  makeAPaymentModalContainerId
} from 'const/modalContainerId'
import i18n from 'strings/i18n'
import {
  ModalHeader,
  SlideInModalPortal
} from 'syf-component-library/ui/patterns/SlideInModalPortal'

import ChangePaymentDueDate from '@account-services-mfe/change-payment-due-date'
import getMFEConfig from 'helpers/getMFEConfig'
import triggerAnalyticsEvent from 'helpers/triggerAnalyticsEvent'
import { getBrandRefreshPhase } from 'helpers/getBrandRefreshPhase'

const ChangePaymentDueDateModal = (): ReactElement => {
  const [{ modalId, modalTriggerId }, updateModalStatus] =
    useAtom(modalStatusAtom)
  const headerRef = useRef(null)

  const selectedAccount = useAtomValue(selectedAccountAtom)

  const mfeConfig = getMFEConfig('mfe')

  const handleCloseModal = () => {
    updateModalStatus('')
  }

  const handleMakeAPayment = () => {
    updateModalStatus('MAP', makeAPaymentModalContainerId(selectedAccount))
  }

  const handleEscapeAndModalHeader = () => {
    triggerAnalyticsEvent({
      pageFunction: 'account services',
      pageKind: 'account services'
    })
    handleCloseModal()
  }

  return (
    <SlideInModalPortal
      containerId={changePaymentDueDateModalContainerId(selectedAccount)}
      escapeModalHandler={handleEscapeAndModalHeader}
      id={`cpdd-slide-in-modal-${selectedAccount}`}
      isOpen={modalId === 'ChangePaymentDueDate'}
      modalTriggerId={modalTriggerId}
      header={
        <ModalHeader
          closeModal={handleEscapeAndModalHeader}
          content={i18n({ modal: 'changeDueDateTitle' }) as string}
          data-test="cpdd-modal-header"
          dataReason="x button"
          dataType="change payment due date"
          headerRef={headerRef}
        />
      }
    >
      <ChangePaymentDueDate
        config={mfeConfig}
        handleClose={handleCloseModal}
        selectedAccountId={selectedAccount}
        handleMakeAPayment={handleMakeAPayment}
        features={{
          brandRefreshPhase: getBrandRefreshPhase()
        }}
      />
    </SlideInModalPortal>
  )
}

export default ChangePaymentDueDateModal
